import { takeLatest } from 'redux-saga/effects';
import { addCartAction } from '@app/react/action/AddCartAction';
import { fetchCartItemAction } from '@app/react/action/fetchCartItem';
import { pushCartEditAction } from '@app/react/action/pushCartEditAction';

import { addCartFlow } from './cartSaga';
import { fetchCartItemSaga } from './fetchCartItemSaga';
import { pushEditCartSaga } from './pushEditCartSaga';

export const cartSaga = [
    takeLatest(addCartAction.started.type, addCartFlow),
    takeLatest(fetchCartItemAction.started.type, fetchCartItemSaga),
    takeLatest(pushCartEditAction.started.type, pushEditCartSaga),
];
